import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getTimeCheckingMonthStart,
  getTimeCheckingMonthSuccess,
  getTimeCheckingMonthFailed,
} from "../redux/getTimekeepingMonth";
import { getTimeCheckingMonthAPI } from "core/http/service/decleareLeave";

function* getTimeCheckingWork(action) {
  const { screenCode, ...payload } = action.payload;
  try {
    const res = yield call(getTimeCheckingMonthAPI, {
      screenCode,
      month: payload.month,
      year: payload.year,
    });
    yield put({
      type: getTimeCheckingMonthSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getTimeCheckingMonthFailed.type,
      payload: {},
    });
  }
}

function* watchGetTimeChecking() {
  yield takeLatest(getTimeCheckingMonthStart.type, getTimeCheckingWork);
}

export default function* getTimeCheckingSaga() {
  yield all([watchGetTimeChecking()]);
}
